<template>
  <div class="flexbox" :class="type == 3 ? 'small' : ''">
    <div class="num">{{ num + 1 }}</div>
    <div class="id" style="font-size: 0.5rem;">{{ arr.nickName?arr.nickName.substring(0, 5):'' }}</div>
    <!-- <img src="@/assets/refresh.png" class="refresh" alt=""> -->
    <div class="data" v-if="!arr.practice">
      <div class="left">
        <div class="color-box">
          <div class="point" v-if="arr.fw && arr.fw == true" :style="{ top: 0 + '%' }"></div>
          <div class="point" v-else :class="arr.value <= 2.5 || !arr.value ? 'yellow' : 'green'" :style="pmove"
            style="transition: top 0.1s ease;"></div>
          <div class="back-white" :style="bmove" style="transition: height 0.1s ease;"></div>
          <div class="all-green" v-if="arr.value >= 5"></div>
          <div class="back-color" v-else></div>
        </div>
        <div class="press">
          {{ arr.total || 0 }}
        </div>
      </div>
      <div class="right">
        <div class="press">
          {{ arr.rate || 0 }}
        </div>
        <div class="rate1" :style="styObj">
          <div class="point_box">
            <div class="point"></div>
            <div class="shan1"></div>
            <div class="line-tick line-tick1">
              <div class="tick"></div>
              <div class="num">0</div>
            </div>
            <div class="line-tick line-tick1">
              <div class="tick"></div>
              <div class="num">0</div>
            </div>
            <div class="line-tick line-tick2">
              <div class="tick"></div>
              <div class="num">100</div>
            </div>
            <!-- <div class="line-tick line-tick3">
              <div class="tick"></div>
              <div class="num"></div>
            </div> -->
            <div class="line-tick line-tick4">
              <div class="tick"></div>
              <div class="num">120</div>
            </div>
            <div class="line-tick line-tick5">
              <div class="tick"></div>
              <div class="num"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data" v-if="arr.practice" @click="goDetail" style="font-size: 60px;align-items: center;justify-content: center;user-select: none;cursor: pointer;">
      {{ arr.practice.passRate }}%
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewBox',
  data() {
    return {
      // rate:50,
      newFw: '',
      timer: "",
      isFw: 'false',
      styleVar: {
        '--topValue': '0'
      },
    }
  },
  props: ['num', 'arr', 'plist', 'type','token','adminId'],
  computed: {
    oldObj() {
      let rotateDeg = "";
      let conicDeg = "";
      let color = ""
      if (this.arr.rate <= 0) {
        // eslint-disable-next-line
        rotateDeg = "rotate(0deg)";
        // eslint-disable-next-line
        conicDeg = "0%";
      } else if (this.arr.rate > 200) {
        // eslint-disable-next-line
        rotateDeg = "rotate(180deg)";
        // eslint-disable-next-line
        conicDeg = "0%";
        color = '#f10f0f'
      } else if (this.arr.rate < 100) {
        // eslint-disable-next-line
        rotateDeg = `rotate(${(this.arr.rate / 100) * 45}deg)`;
        // eslint-disable-next-line
        conicDeg = "0%";
        color = '#f10f0f'
      } else if (this.arr.rate > 100 && this.arr.rate <= 120) {
        // eslint-disable-next-line
        rotateDeg = `rotate(${45 + ((this.arr.rate - 100) * 4.5)}deg)`;
        // eslint-disable-next-line
        conicDeg = "0%";
        color = '#f10f0f'
      } else {
        // eslint-disable-next-line
        rotateDeg = `rotate(${(this.arr.rate / 200) * 180}deg)`;
        // eslint-disable-next-line
        conicDeg = `${(this.arr.rate / 200) * (180 / 360) * 100}%`;
        // eslint-disable-next-line
        if (this.arr.rate < 90) {
          color = '#f5e226'
        } else if (this.arr.rate > 120) {
          color = '#f10f0f'
        } else {
          color = '#62db00'
        }
      }

      return {
        "--background-wrapper": `conic-gradient(${color} 0%, ${color} ${conicDeg}, transparent ${conicDeg})`,
        "--background-inner": `conic-gradient(#073358 0%, ${color} ${conicDeg}, transparent ${conicDeg})`,
        "--pointer-rotate": rotateDeg,
      }

    },
    styObj() {
      let rotateDeg = "";
      let conicDeg = "";
      let color = ""
      if (this.arr.rate <= 0) {
        // eslint-disable-next-line
        rotateDeg = "rotate(0deg)";
        // eslint-disable-next-line
        conicDeg = "0%";
      } else if (this.arr.rate <= 100 && this.arr.rate > 0) {
        // eslint-disable-next-line
        rotateDeg = `rotate(${(this.arr.rate / 100) * 45}deg)`;
        // eslint-disable-next-line
        conicDeg = `${(this.arr.rate / 100) * (45 / 360) * 100}%`;
        color = 'rgba(245, 224, 38,.8)'
      } else if (this.arr.rate >= 100 && this.arr.rate <= 120) {
        // eslint-disable-next-line
        rotateDeg = `rotate(${45 + ((this.arr.rate - 100) / 20) * 90}deg)`;
        // eslint-disable-next-line
        conicDeg = `${((this.arr.rate - 100) / 20) * 0.5 * 50 + 12.5}%`;
        color = 'rgba(99, 219, 0,.8)'
      } else if (this.arr.rate > 120) {
        // eslint-disable-next-line
        rotateDeg = "rotate(180deg)";
        // eslint-disable-next-line
        conicDeg = "50%";
        color = 'rgba(241, 14, 14,.8)'
      }

      return {
        "--background-wrapper": `conic-gradient(${color} 0%, ${color} ${conicDeg}, transparent ${conicDeg})`,
        "--background-inner": `conic-gradient(rgba(255,255,255,.3) 0%, ${color} ${conicDeg}, transparent ${conicDeg})`,
        "--pointer-rotate": rotateDeg,
      }

    },
    pmove() {
      if (this.arr.value == 0 || !this.arr.value) {
        return {
          '--top-press': 0 + '%',
          '--top-border': "none"
        }
      } else if (this.arr.value > 0 && this.arr.value < 5) {
        return {
          // '--top-press': (this.arr.value-2)*100/3 + '%',
          '--top-press': parseFloat(this.arr.value) * 20 + '%',
          '--top-border': "none"
        }
      } else if (this.arr.value >= 5) {
        return {
          '--top-press': 100 + '%',
          '--top-border': "2px solid #fff"
        }
      }
    },
    bmove() {
      if (this.arr.value == 0 || !this.arr.value) {
        return {
          '--cc-back': 100 + '%'
        }
      } else if (this.arr.value > 0 && this.arr.value <= 5) {
        return {
          // '--cc-back': (100-(this.arr.value-2)*100/3) + '%'
          '--cc-back': (100 - parseFloat(this.arr.value) * 20) + '%'
        }
      } else if (this.arr.value >= 5) {
        return {
          '--cc-back': 0 + '%'
        }
      }
    }
  },
  methods: {
    goDetail() {
      this.$router.push({ name: 'detail2', query: { pid:this.arr.practice.id,token: this.token, adminId: this.adminId } })
    },
  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
.flexbox.small {
  zoom: 0.6;
}

.flexbox {
  width: 5.6rem;
  max-width: 325px;
  height: calc(0.7*6rem);
  max-height: calc(0.7*325px);
  background: rgba(255, 255, 255, .4);
  margin-bottom: .8rem;
  position: relative;
  border-radius: .15rem;
  overflow: hidden;

  .num {
    color: #9ea3a3;
    font-size: .5rem;
    position: absolute;
    left: .125rem;
    top: .0625rem;
    z-index: 10;

    @media screen and (min-width: 1400px) {
      font-size: 24px;
    }
  }

  .id {
    color: #9ea3a3;
    position: absolute;
    //bottom: .16rem;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: .2rem;

    @media screen and (min-width: 1400px) {
      font-size: 12px;
    }
  }

  .refresh {
    position: absolute;
    width: .7rem;
    right: .1rem;
    bottom: .16rem;
    max-width: 30px;
  }

  .status {
    width: 100%;
    height: 100%;
    position: relative;
    background: #575757;
    z-index: 9;

    img {
      width: 40%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }

  .data {
    width: 4.6rem;
    max-width: 295px;
    height: calc(0.7*4rem);
    max-height: calc(0.6*255px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    display: flex;

    .left {
      width: 40%;
      height: 100%;
      justify-content: center;
      text-align: center;
      flex-direction: column;

      .reback:nth-child(1) {
        .line {
          background: #f10f0f !important;
        }
      }

      .color-box {
        background: rgba(255, 255, 255);
        width: 40%;
        height: 80%;
        margin: 0 auto;
        border-radius: .1rem;
        position: relative;

        .point {
          height: .1rem;
          width: 130%;
          position: absolute;
          top: calc(var(--top-press) - 0.05rem);
          border: var(--top-border);
          background: #f10f0f;
          left: -15%;
          border-radius: .1rem;
          z-index: 3;
          transition: top 0.1s ease;
        }

        .point.yellow {
          background: #fffc00;
        }

        .point.green {
          background: #7eff00;
        }

        .back-white {
          position: absolute;
          background: #fff;
          width: 100%;
          height: var(--cc-back);
          border-radius: 0 0 .1rem .1rem;
          bottom: 0;
          z-index: 2;
        }

        .back-color {
          position: absolute;
          background: linear-gradient(#f5e226 0, #f5e226 50%, #62db00 0, #62db00);
          width: 100%;
          height: 100%;
          border-radius: .1rem;
          z-index: 1;
        }

        .all-green {
          position: absolute;
          background: #62db00;
          width: 100%;
          height: 100%;
          border-radius: .1rem;
          z-index: 1;
        }

        .change-color {
          position: absolute;
          width: 100%;
          z-index: 1;
        }

        .change-color.yellow {
          top: 0;
          background: #f5e226;
          border-radius: .1rem .1rem 0 0;
        }

        .change-color.green {
          top: 50%;
          background: #62db00;
        }
      }

      .press {
        font-size: 0.45rem;
        text-align: center;
        margin: .1rem;
        color: #7a7b7b;
      }

      .line_box {
        width: 100%;
        height: 100%;
        flex: 1;
        display: flex;

        .line {
          display: block;
          width: 90%;
          height: .065rem;
          margin: auto;
          border-radius: 2px;
          background: #f5e226;
        }

        .line.yellow {
          background: #f5e226;
        }

        .line.green {
          background: #62db00;
        }
      }
    }

    .right {
      width: 60%;
      height: 100%;
      text-align: center;
      position: relative;

      .press {
        color: #7a7b7b;
        font-weight: 500;
        position: absolute;
        white-space: nowrap;
        font-size: .65rem;
        // top: .225rem;
        left: 50%;
        transform: translateX(-50%);

        @media screen and (min-width: 1400px) {
          // font-size: 18px;
        }
      }

      .rate {
        color: #fff;
        font-size: 1.4rem;
        position: absolute;
        bottom: .2rem;
        left: 50%;
        transform: translateX(-50%);

        @media screen and (min-width: 1400px) {
          font-size: 72px;
        }
      }

      .rate.yellow {
        color: #f5e226;
      }

      .rate.red {
        color: #f10f0f;
      }

      .rate1::after {
        content: "";
        position: absolute;
        width: 2.4rem;
        height: 2.4rem;
        top: 0;
        left: 0;
        border-radius: 100%;
        z-index: -1;
        background-image: var(--background-inner);
        transform: rotate(-90deg);
        transition: background-image 2s;

        @media screen and (min-width: 1400px) {
          width: 120px;
          height: 120px;
        }
      }

      .rate1 {
        width: 100%;
        left: 50%;
        transform: translateX(-50%);
        height: 1.2rem;
        width: 2.4rem;
        border-radius: 2.4rem 2.4rem 0 0;
        position: absolute;
        bottom: .4rem;
        border: 3px solid #7a7b7b;
        border-bottom: none;

        @media screen and (min-width: 1400px) {
          height: 60px;
          width: 120px;
          border-radius: 120px 120px 0 0;
        }

        .point_box {
          width: 100%;
          height: 100%;
          position: relative;

          .point {
            width: 35%;
            height: 1px;
            background: #9ea3a3;
            position: absolute;
            bottom: 0px;
            right: 50%;
            // clip-path: polygon(0 1px, 40px 0, 40px 40px);
            transform-origin: right center;
            transition: transform 1s;
            transform: var(--pointer-rotate);
          }

          .line-tick {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 1.2rem;
            height: 2px;
            transform-origin: right center;

            @media screen and (min-width: 1400px) {
              width: 60px;
            }

            .tick {
              width: 10%;
              height: 100%;
              background: #9ea3a3;
            }

            .num {
              color: #7a7b7b;
              font-size: 0.2rem;
            }
          }

          .line-tick1 .num {
            position: absolute;
            left: -0.2rem;
            top: -5px;
          }

          .line-tick2 {
            transform: rotate(45deg);
          }

          .line-tick2 .num {
            position: absolute;
            left: -0.3rem;
            top: -5px;
            transform: rotate(-90deg);
          }

          .line-tick3 {
            transform: rotate(90deg);
          }

          .line-tick3 .num {
            position: absolute;
            left: -0.3rem;
            top: -5px;
            transform: rotate(-90deg);
          }

          .line-tick4 {
            transform: rotate(135deg);
          }

          .line-tick4 .num {
            position: absolute;
            left: -0.3rem;
            top: -5px;
            transform: rotate(-90deg);
          }

          .line-tick5 {
            transform: rotate(180deg);
          }

          .line-tick5 .num {
            position: absolute;
            left: -0.4rem;
            top: -5px;
            transform: rotate(180deg);
          }
        }

        // .point_box:hover .point{
        //   transform: rotate(180deg);
        // }

      }
    }
  }
}
</style>
